import ColorsCard from "../../../../src/components/CardColor/CardColor.jsx";
import * as React from 'react';
export default {
  ColorsCard,
  React
};